import * as React from "react";

const ChevronUpSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <g clip-path="url(#clip0_19962_42706)">
                <path d="M20.1284 18.0098L21.8984 16.2298L11.9984 6.33984L2.09844 16.2398L3.86844 18.0098L11.9984 9.87984L20.1284 18.0098Z" fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_19962_42706">
                    <rect width="24" height="24" fill="white" transform="matrix(0 1 -1 0 24 0.5)"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(ChevronUpSmall);
